module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/domains/bravenet_domains_privacy_protection.png";